import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import axios from 'axios';
import Spin from 'components/Spin';

const Academy = () => {
  const user = useSelector((s) => s.user.user);
  const [content, setContent] = useState(null);

  useEffect(() => {
    axios
      .post(
        'https://textinchurch.acadle.com/widget2/index',
        {
          name: `${user.user_first_name} ${user.user_last_name}`,
          email: user.user_username,
          group: [2],
        },
        {
          headers: {
            Authorization: 'aZ2ZnqqeqbSsOFpERjQx',
          },
        },
      )
      .then((resp) => {
        setContent(resp.data.data);
      });
  }, []);

  return (
    <Box>
      {!content ? (
        <Spin spinning />
      ) : (
        <Box
          height="calc(100vh - 64px)"
          overflow="auto"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </Box>
  );
};
export default Academy;
